export const useIsMobile = () => {
  const isMobile = ref(false);

  if (typeof window === "undefined" || !window.matchMedia) {
    return { isMobile };
  }

  const mediaQuery = window.matchMedia("(max-width: 768px)");

  const handleChange = (event: MediaQueryListEvent) => {
    isMobile.value = event.matches;
  };

  isMobile.value = mediaQuery.matches;
  mediaQuery.addEventListener("change", handleChange);

  onBeforeUnmount(() => {
    mediaQuery.removeEventListener("change", handleChange);
  });

  return { isMobile };
};
